import React from 'react';

// import imageWeb from '../../assets/hero/web.png';

import './Hero.css';

const Hero = () => {

    // const [isLoaded, setIsLoaded] = useState(false);

    return (
        <div className="hero">
            <img className={`hero-image`}
            //  src="https://firebasestorage.googleapis.com/v0/b/onerock-vag-website.appspot.com/o/website%20hd%20image%201.png?alt=media&token=72ae7af3-52fa-485a-9f42-8ca28639f499"
             alt="hero-bhavik"
             src="https://firebasestorage.googleapis.com/v0/b/onerock-vag-website.appspot.com/o/Untitled-4.jpg?alt=media&token=6e73f41e-c307-44b0-ad1f-a8754ff7c0d9"
            //  src="https://firebasestorage.googleapis.com/v0/b/onerock-vag-website.appspot.com/o/cropped%20hd%20image_compressed.jpg?alt=media&token=674c2d97-7516-4085-960b-ec09257650a6" 
            />
        </div>
    );
};

export default Hero;


// WEBPACK FOOTER //
// ./src/components/hero/Hero.js